import './TextInputStyle.css';
import { Input } from 'antd';
const { TextArea } = Input;

//takes an onChange prop and calls it with (dataKey, newValue)
const TextAreaInput = props => {
    const { def, data, onChange, state, warning } = props;
    const err = warning !== undefined && warning !== '' ? "error" : "";

    const checkText = (value) => {
        if (value.length > def.maxLength && !err) return;
        else if (value.length > def.maxLength) {
            onChange(def.dataKey, value, warning);
        }
        else {
            onChange(def.dataKey, value);
        }
    }

    return <TextArea
        id={def.dataKey}
        value={data}
        readOnly={state.readOnly}
        data-input={'textareainput_de'}
        className={'basicinput_de'}
        onChange={ev => checkText(ev.target.value)}
        placeholder={def.placeholder}
        status={err}
        rows={3}
    />
}

export default TextAreaInput;
